module.exports = __webpack_public_path__ + "static/media/page18c.7d5dab8d.png";